export const mainApi = 'https://lucero.zakirabd.com/public/api'